export default __webpack_public_path__ + "static/media/Lexil - À temps.c693a5b9.mp3";